<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card>
            <v-card-title class="justify-center primary" icon>
                <v-toolbar-title id="titulocard">Reclasificación de documentos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">mdi-cached</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <div>
                            <span class="type-label-style">
                                Tipo Documento:
                            </span>
                            <p class="type-text-style">{{archivo.dodescrip}}</p>
                        </div>
                        <v-divider class="mt-1"></v-divider>
                        <div>
                            <span class="type-label-style">
                                Iniciales:
                            </span>
                            <p class="type-text-style">{{archivo.doiniciales}}</p>
                        </div>
                        <v-divider class="mt-1"></v-divider>
                        <div>
                            <span class="type-label-style">
                                Tipo Documento Destino de Reclasificación:
                            </span>
                            <multiselect v-model="tipoDoc.doclave"
                                         deselect-label="No se puede remover el valor seleccionado"
                                         selected-label="Seleccionado"
                                         select-label="Seleccione tipo de docuemento"
                                         track-by="doclave" label="dodescrip"
                                         placeholder="Seleccione una opción"
                                         :options="tipoDoc.opcionesDoc"
                                         :allow-empty="false"
                                         @select="removeMultiSelectError()">
                            </multiselect>
                            <span style="color: red; display: none" id="opcError"> Debe seleccionar una opción </span>
                        </div>
                        <br />
                        <div>
                            <v-alert color="blue" type="success">
                                Tiene que seleccionar el o los archivos que desea reclasificar
                            </v-alert>
                        </div>
                    </v-col>

                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <v-list two-line v-if="ver" style="border: solid;">
                            <v-list-item-group v-model="selected"
                                               active-class="primary--text"
                                               multiple>
                                <template v-for="(item, name, index) in archiver">
                                    <v-list-item :key="item.pagina" :disabled="item.disabled">
                                        <template v-slot:default="{ active, toggle }">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Nombre: {{item.nombre}}
                                                </v-list-item-title>
                                                <v-list-item-subtitle>Tipo: {{item.tipo}} </v-list-item-subtitle>
                                                <v-row >
                                                    <v-btn class="primary ma-2 mt-6 ml-4"
                                                           @click="VerArchivo(item)">
                                                        Ver
                                                    </v-btn>
                                                </v-row>
                                            </v-list-item-content>

                                            <v-list-item-action>
                                                <v-icon v-if="!active"
                                                        :color="thema">
                                                    mdi-check-bold-outline
                                                </v-icon>

                                                <v-icon v-else
                                                        :color="thema">
                                                    mdi-check-bold
                                                </v-icon>
                                            </v-list-item-action>
                                        </template>
                                    </v-list-item>
                                </template>
                            </v-list-item-group>
                        </v-list>
                        <span style="color: red; display: none; text-align: center;" id="selectError"> Debe seleccionar al menos un archivo a reclasificar </span>
                    </v-col>
                </v-row>

                    <br />
                    <v-row justify="center">
                        <v-col cols="12" class="text-center">
                            <v-btn class="ma-2"
                                   @click="Guardar()"
                                   color="primary"
                                   :disabled="disable">
                                Guardar
                                <template v-slot:loader>
                                    <span>Loading...</span>
                                </template>
                            </v-btn>
                            <v-btn class="ma-2" @click="Limpiar()" color="default">
                                Limpiar
                            </v-btn>
                            <v-btn class="ma-2" @click="Regresar()" color="error">
                                Regresar
                            </v-btn>
                        </v-col>
                    </v-row>
            </v-card-text>
        </v-card>
        <div v-show="showLightbox">
            <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                      @onClosed="CerrarVisor()" />
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex'
    import Archivos from '@/services/Archivos/Archivos.service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import LightBox from '@/components/pages/Visor/LightBox.vue';
    import LocalStorage from '@/utils/managerLocalStorage.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            LightBox
        },
        data() {
            return {
                showcargando: true,
                overlay: false,
                sPDF: false,
                media: [{
                    src: '@/',
                    type: ''
                }],
                showLightbox: false,
                datos: {},
                archivo: {},
                selected: [],
                recla: false,
                tipoDoc: {
                    opcionesDoc: [],
                    doclave: '',
                    dodescrip: ''
                },
                tipo: 1,
                aiclave: '',
                disable: false,
                loader: false,
                validTipo: null,
                validaselec: null,
                archiver: [],
                ver: false,
                thema: 'primary darken-1',
            }
        },
        methods: {
            async obtenerArchivo(pagina) {
                let formdata = new FormData();
                formdata.append("nrreporte", this.datos.nrreporte);
                formdata.append("svindice", this.datos.svindice);
                formdata.append("docid", this.archivo.docid);
                formdata.append("pagina", pagina);
                let archi = await Archivos.ObtenerEnlaces(formdata);
                return archi.watch;
            },
            Limpiar() {
                this.tipoDoc.doclave = '';
                this.selected = [];
                document.getElementById("opcError").style.display = "none";
                document.getElementById("selectError").style.display = "none";
            },
            removeMultiSelectError() {
                document.getElementById("opcError").style.display = "none";
            },
            Regresar() {
                this.$router.go(-1);
            },
            async VerArchivo(item) {
                let reporte = {
                    nrreporte: this.datos.nrreporte,
                    svindice: this.datos.svindice,
                };

                this.showLightbox = false;
                this.overlay = true;
                this.media = this.media.filter(obj => obj.src == '@/');
                this.isPDF = /\.pdf$/i.test(item.nombre);
                let dir = await Archivos.ObtenerDireccion(this.datos, this.archivo.docid, item.pagina);
                var formData = new FormData();
                formData.append("lasitio", 'Prusia+');
                formData.append("lomodulo", 'Documentos');
                formData.append("laaccion", "Vio Documento");
                formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                formData.append("lanombre", dir.archivo);
                formData.append("ladestinatario", "");

                await Archivos.AlmacenarVisitas(formData);
                if (dir.archivo !== null) {
                    var img = {
                        src: dir.watch,
                        caption: '<h4>' + this.archivo.dodescrip + '</h4>',
                        type: this.isPDF == true ? 'pdf' : 'img',
                        width: '800px',
                        docid: this.archivo.docid,
                        paginas: 1,
                    };
                    this.media.push(img);
                    this.media = this.media.filter(obj => obj.src !== '@/');
                    this.showLightbox = true;
                } else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Error',
                        text: dir.msg,
                        showConfirmButton: false,
                        timer: 2500
                    });
                    this.verarchi = false;
                }
                this.overlay = false;
            },
            async CerrarVisor() {
                var img = {
                    src: '@/',
                    type: 'img'
                }
                this.media = [];
                this.media.push(img);
                this.showLightbox = false;
                await this.$refs.lightbox.showImage(0);
            },
            async Guardar() {
                this.validTipo = this.tipoDoc.doclave == "" ? false : true;
                this.validaselec = this.selected.length > 0 ? true : false;
                if (this.validTipo == false) { document.getElementById("opcError").style.display = "block"; }
                if (this.validaselec == false) { document.getElementById("selectError").style.display = "block"; }

                if (this.validTipo && this.selected.length > 0) {
                    this.$swal({
                        title: "Procesando la reclasificación...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                    });
                    this.$swal.showLoading();
                    let numpagina = [];
                    let noslect = [];
                    await this.selected.forEach(object => {
                        numpagina.push({ pagina: object + 1, nombre: this.archiver[object].nombre });
                    });

                    for (let i = 1; i <= this.archivo.docpaginas; i++) {
                        if (numpagina.filter(item => item.pagina == i).length == 0)
                            noslect.push({ pagina: i, nombre: this.archiver[i - 1].nombre });
                    }
                    let form = new FormData();
                    form.append("reporte", this.datos.nrreporte);
                    form.append("indice", this.datos.svindice);
                    form.append("docid", this.archivo.docid);
                    form.append("numpagina", JSON.stringify(numpagina));
                    form.append("doclave", this.tipoDoc.doclave.doclave);
                    form.append("noselect", JSON.stringify(noslect));
                    form.append("doclaveini", this.archivo.doclave);
                    Archivos.Reclasificar(form).then(data => {
                        if (data.success) {
                            let datas = data.data;
                            if (datas.length == 0) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito",
                                    text: "La reclasificación se guardó con éxito.",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true,
                                    timer: 4000,
                                }).then(() => {
                                    this.$router.go(-1);
                                });
                            }
                            else {
                                let tabla = '';
                                tabla = "<div style='text-align: center;'><table style='margin: 0 auto;'>";
                                for (var i = 0; i < datas.length; i++) {
                                    tabla += "<tr>";
                                    tabla += "<td style='padding:  8px 8px;'>" + datas[i].Archivo + "</td>";
                                    if (datas[i].tipo == 'Eliminar')
                                        tabla += "<td style='padding:  8px 8px; text-align: justify'>Ocurrió un error, no se eliminó el archivo</td>";
                                    else
                                        tabla += "<td style='padding:  8px 8px; text-align: justify'>Ocurrió un error, no se reclasificó el archivo</td>";
                                    
                                    tabla += "</tr>";
                                }
                                tabla += "</table></div>"

                                this.$swal({
                                    position: "center",
                                    title: "Atención",
                                    html: tabla,
                                    icon: "info",
                                    width: "50%",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    confirm: false,
                                    timer: 6000,
                                }).then(() => {
                                    this.$router.go(-1);
                                });
                            }
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "info",
                                title: "Atención",
                                text: data.msg,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 4000,
                            });
                        }
                    });
                }

            },
        },
        watch: {
            validTipo(val) {
                if (val == true) {
                    document.getElementById("opcError").style.display = "none";
                } else {
                    document.getElementById("opcError").style.display = "block";
                }
            },
            'selected'(val) {
                if (this.selected.length > 0)
                    document.getElementById("selectError").style.display = "none";
            },
           'theme'(val) {
                if (val)
                    this.thema = 'white';
                else
                    this.thema = 'primary darken-1';
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage', 'theme']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        async mounted() {
            let local = LocalStorage.getSingleValueInLocalStorage("tema");
            if (local.nocturno == true) {
                this.thema = 'white';
            }
            else
                this.thema = 'primary darken-1';
            this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            if (this.datos != undefined) {
                
                this.archivo = this.datos;

                this.aiclave = this.datos.aiclave;

                for (var i = 1; i <= this.archivo.docpaginas; i++) {
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("docid", this.archivo.docid);
                    formdata.append("pagina", i);
                    let archi = await Archivos.ObtenerEnlaces(formdata);
                    this.archiver.push({
                        nombre: archi.archivo != '' ? archi.archivo : "No existe este archivo",
                        pagina: i,
                        url: archi.watch,
                        tipo: archi.archivo == '' ? 'No existe el archivo' : /\.pdf$/i.test(archi.archivo) == true ? 'PFD' : 'Imagen',
                        disabled: archi.archivo != '' ? false : true,
                    });
                }
                if (this.datos.aiclave == 26) {
                    await Archivos.ObtenerCatalogoDocumentos(this, this.datos);
                } else {
                    await Archivos.ObtenerCatalogoDocs(this, this.datos);
                }

                this.tipoDoc.opcionesDoc = this.tipoDoc.opcionesDoc.filter(item => item.doclave != this.datos.doclave)
                this.showcargando = false;
                this.ver = true;
            }
            else {
                this.$router.go(-1);
            }
        }
    }
</script>